<template>
  <keep-alive>
      <EsimProfileList />
  </keep-alive>
</template>
<script>
import EsimProfileList from './EsimProfileList/EsimProfileList.vue'
export default {
  components: {
    EsimProfileList
  }
}
</script>
